import ReactPaginate from 'react-paginate';
import classNames from 'classnames';
import { SelectedPage } from '@/features/navigation/types';
import { PaginationBackArrow, PaginationNextArrow } from './arrows';
import PaginationSkeleton from './pagination-skeleton';
import { PaginationArrowSize } from './type';
interface Props {
  page: number;
  pageCount: number;
  onPageChange: (page: number) => void;
  size: PaginationArrowSize;
  className?: string;
  hrefBuilder?: (page: number) => string;
  isLoading?: boolean;
}
const Pagination = ({
  page,
  onPageChange,
  pageCount,
  size,
  className = '',
  isLoading = false,
  hrefBuilder
}: Props) => {
  const pageChangeHandler = (newPage: SelectedPage) => {
    onPageChange(newPage.selected + 1);
  };
  if (pageCount <= 1) return null;
  const itemsClassName = classNames('rounded-md flex items-center justify-center', {
    'h-8 w-8 text-body-16': size === PaginationArrowSize.Large,
    'h-6 w-6 text-body-14': size !== PaginationArrowSize.Large
  });
  if (isLoading) return <PaginationSkeleton />;
  return <ReactPaginate forcePage={page ? page - 1 : 0} className={classNames('flex flex-wrap items-center justify-center text-text-darkGray', className)} activeLinkClassName='border bg-surface-solid-50 border-primary-main text-primary-main' disabledLinkClassName='text-text-lightGray' disabledClassName='[&>a]:cursor-default' pageLinkClassName={itemsClassName} nextLinkClassName={itemsClassName} previousLinkClassName={itemsClassName} breakClassName={itemsClassName} nextLabel={<PaginationNextArrow size={size} />} previousLabel={<PaginationBackArrow size={size} />} breakLabel='...' pageRangeDisplayed={2} marginPagesDisplayed={2} onPageChange={pageChangeHandler} pageCount={pageCount} renderOnZeroPageCount={null} hrefBuilder={hrefBuilder} disableInitialCallback hrefAllControls data-sentry-element="ReactPaginate" data-sentry-component="Pagination" data-sentry-source-file="pagination.tsx" />;
};
export default Pagination;